var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { jsonPost } from '@square/dashboard-utilities/utils/xhr';
import Service, { inject as service } from '@ember/service';
import { InstallationActionSource } from '@square/dashboard-protos/models/squareup/addons/data/installation_action_source';
import { ListAllAddonsRequest, ListAllAddonsResponse } from '@square/dashboard-protos/models/squareup/addons/external/list_all_addons';
import { v4 as uuid } from 'uuid';
import { captureException } from '@sentry/browser';
import DeviceProfileError, { ADDON_INSTALL_ERROR, ADDON_UNINSTALL_ERROR, DeviceProfileMessage } from '@square/dashboard-data/models/device-profiles-v2/device-profile-error';
import { isEmpty } from '@ember/utils';
import { camelize, underscore } from '@square/dashboard-utilities/utils/keys';
import { InstallAddonRequest, InstallAddonResponse } from '@square/dashboard-protos/models/squareup/addons/external/install_addon';
import { UninstallAddonRequest, UninstallAddonResponse } from '@square/dashboard-protos/models/squareup/addons/external/uninstall_addon';
const ADDONS_URL_PREFIX = '/api/v1/addons';
const ADDONS_LIST_URL = `${ADDONS_URL_PREFIX}/list_all_addons`;
const ADDONS_INSTALL_URL = `${ADDONS_URL_PREFIX}/install`;
const ADDONS_UNINSTALL_URL = `${ADDONS_URL_PREFIX}/uninstall`;
const IS_DPV2_ADDON_HEADER = 'Is-DPv2-Dashboard';
const ADDONS_REQUEST_HEADERS = {
  [IS_DPV2_ADDON_HEADER]: 'true'
};
let Addons = (_class = class Addons extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
  }
  getAddons(filteredAddons = []) {
    const listAddonsRequest = ListAllAddonsRequest.create({
      installedOnly: false
    });
    const json = underscore(listAddonsRequest.toJSON());
    return jsonPost(ADDONS_LIST_URL, json, {
      headers: ADDONS_REQUEST_HEADERS
    }).then(resp => {
      const proto = ListAllAddonsResponse.fromObject(camelize(resp));
      if (!proto.success) {
        // add error
        return [];
      }
      return proto.addon.filter(addon => isEmpty(filteredAddons) || filteredAddons.includes(addon.firstPartyAddon));
    }).catch(err => {
      captureException(err);
      return [];
    });
  }
  installAddon(firstPartyAddon) {
    const installRequest = InstallAddonRequest.create({
      firstPartyAddon,
      idempotenceKey: uuid(),
      shouldEnable: true,
      actingEmployeeToken: this.userInfo.employmentToken,
      actionSource: InstallationActionSource.DASHBOARD_ACTION,
      populateAddonInResponse: true
    });
    const json = underscore(installRequest.toJSON());
    return jsonPost(ADDONS_INSTALL_URL, json, {
      headers: ADDONS_REQUEST_HEADERS
    }).then(resp => {
      const proto = InstallAddonResponse.fromObject(camelize(resp));
      if (!proto.success) {
        throw new DeviceProfileMessage(proto.localizedErrorMessage, ADDON_INSTALL_ERROR);
      }
      return proto.addon;
    }).catch(err => {
      captureException(err);
      throw new DeviceProfileError('Error installing addon', err, {
        status: ADDON_INSTALL_ERROR
      });
    });
  }
  uninstallAddon(firstPartyAddon) {
    const uninstallRequest = UninstallAddonRequest.create({
      firstPartyAddon,
      idempotenceKey: uuid(),
      shouldDisable: true,
      actingEmployeeToken: this.userInfo.employmentToken,
      actionSource: InstallationActionSource.DASHBOARD_ACTION,
      populateAddonInResponse: true
    });
    const json = underscore(uninstallRequest.toJSON());
    return jsonPost(ADDONS_UNINSTALL_URL, json, {
      headers: ADDONS_REQUEST_HEADERS
    }).then(resp => {
      const proto = UninstallAddonResponse.fromObject(camelize(resp));
      if (!proto.success) {
        throw new DeviceProfileMessage(proto.localizedErrorMessage, ADDON_INSTALL_ERROR);
      }
      return proto.addon;
    }).catch(err => {
      captureException(err);
      throw new DeviceProfileError('Error uninstalling addon', err, {
        status: ADDON_UNINSTALL_ERROR
      });
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { Addons as default };